import { z } from 'zod'

/** Mirrors the Prisma `AuditActorType` enum. */
export const AUDIT_ACTOR_TYPES = ['API_KEY', 'SIGNER', 'STAFF', 'SYSTEM', 'TENANT_USER'] as const

export const auditActorTypeSchema = z.enum(AUDIT_ACTOR_TYPES)

export type AuditActorType = z.infer<typeof auditActorTypeSchema>
